import RecargoList from './RecargoList'
export { RecargoList }
export default RecargoList
